import React from "react";
import { MDialog } from "components/molecules";
import { EMDialogType } from "components/molecules/MDialog";
import { I18nTranslator } from "utils/i18n";
import { translations } from "utils/i18n";
import { Box, DialogContent, Typography } from "@mui/material";

const ImportDocumentDialog = (props: {
  title: string;
  open: boolean;
  loading: boolean;
  handleConfirm(): void;
  handleClose(): void;
  fileName: string;
  isImportNewDocs: boolean;
  updateItemName: string;
}) => {
  const {
    title,
    open,
    loading,
    handleConfirm,
    handleClose,
    fileName,
    isImportNewDocs,
    updateItemName,
  } = props;
  return (
    <MDialog
      title={title}
      type={EMDialogType.NORMAL}
      open={open}
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      loading={loading}
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography marginRight={"6px"}>
            {I18nTranslator(
              isImportNewDocs
                ? translations.receive.askImportDocs
                : translations.receive.askUpdateDocs
            )}
          </Typography>
          {fileName && (
            <Typography marginRight={"6px"} fontWeight={"700"}>
              {fileName}
            </Typography>
          )}
          <Typography marginRight={"6px"}>
            {I18nTranslator(
              isImportNewDocs
                ? translations.receive.askImportTo
                : translations.receive.askUpdateTo,
              {
                code: updateItemName,
              }
            )}
          </Typography>
        </Box>
      </DialogContent>
    </MDialog>
  );
};

export default ImportDocumentDialog;
